import { FC } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { HistoryTable } from 'bank-entity-history/src/components/HistoryTable'
import { TableDataQa } from 'commons/types/enums'
import { Dialog, DialogFace } from 'ui/components/Dialog'

import { HistoryProps } from './History.types'

const routeApi = getRouteApi('/_app/bsa/batch-details/$id')

export const History: FC<HistoryProps> = (props) => {
  const { isPending, isOpen, data, onClose } = props
  const navigate = routeApi.useNavigate()
  const {
    id,
    form: { historyPage, historySize },
    historyTotalCount,
    history
  } = data

  if (!isOpen) {
    return null
  }

  return (
    <Dialog
      id={`batch-${id}-history`}
      onClose={onClose}
      face={DialogFace.PRIMARY}
      title={`Batch ID ${id}`}
      subTitle=" History"
    >
      <HistoryTable
        loading={isPending}
        dataQa={TableDataQa.BP_BSA_REPORTING_BATCH_HISTORY}
        items={history}
        pagination={{
          total: historyTotalCount,
          page: historyPage,
          size: historySize,
          onChange: (page, size) => {
            navigate({ to: '.', search: (prev) => ({ ...prev, historyPage: page, historySize: size }) })
          }
        }}
      />
    </Dialog>
  )
}
